import resolveColor from '../../resolvers/ColorResolver';
import resolveDefinitionValue from '../../resolvers/DefinitionResolver';
import resolveResponsiveValue from '../../resolvers/ResponsiveValueResolver';
export default function resolveFont(theme, screenWidth, fontSupport) {
    var result = {};
    if (fontSupport.fontFamily !== undefined) {
        result.fontFamily = resolveDefinitionValue(theme, screenWidth, theme.typography.fontFamilies, fontSupport.fontFamily);
    }
    if (fontSupport.fontSize !== undefined) {
        result.fontSize = resolveDefinitionValue(theme, screenWidth, theme.typography.fontSizes, fontSupport.fontSize);
    }
    if (fontSupport.fontWeight !== undefined) {
        var fontWeight = resolveDefinitionValue(theme, screenWidth, theme.typography.fontWeights, fontSupport.fontWeight);
        if (typeof fontWeight === 'string') {
            result.fontFamily = fontWeight;
        }
        else {
            result.fontWeight = fontWeight;
        }
    }
    if (fontSupport.fontColor !== undefined) {
        result.color = resolveColor(theme, screenWidth, fontSupport.fontColor);
    }
    if (fontSupport.lineHeight !== undefined) {
        result.lineHeight = resolveResponsiveValue(theme, screenWidth, fontSupport.lineHeight);
    }
    return result;
}
//# sourceMappingURL=FontResolver.js.map